import * as React from "react";
import { Container, IconButton, ListItem } from "@mui/material";
import { Card, CardContent } from "@mui/material";
import { Button } from "@mui/material";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { CSDataTableColumns } from "../../../modal/CSDataTable";
import CSDataTable from "../../../components/CSDataTable";
import DialogBoxForm from "./DialogBoxThreatSource/DialogBoxThreatSourceForm";
import { useRiskAssessmentContext } from "../../../context/RiskAssessment/RiskAssessmentContext";
import { useEffect, useState } from "react";
import { deleteIThreat, getThreats, getExistingThreat, deleteMultipleIThreat } from "./helper";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import { exportExcelThreatSource } from "../utils";
import { useRef } from "react";
import { IThreat, IThreatImport } from "./modal";
import { CircularProgress } from "@mui/material";
import { TsImport } from "./Component/ThreatSourceImport";
import { useUserContext } from "../../../context/auth/UserContext";
import { useAccessRights } from "../../../utils/useAccessRights";

export default function RiskAssesmentThreatSource() {
  const riskAssesment_CS_Access = useAccessRights("Risk Assessment - CS");

  const columns: CSDataTableColumns[] = [
    {
      accessorKey: "threatName",
      header: "Name",
      size: "70px",
    },
    {
      accessorKey: "edit",
      header: "",
      size: "30px",
      isEditable: riskAssesment_CS_Access?.isUpdate,
    },
    {
      accessorKey: "delete",
      header: "",
      size: "30px",
      isDeletable: riskAssesment_CS_Access?.isDelete,
    },
  ];

  const navigate = useNavigate();

  const { userId, companyProfileID } = useUserContext();
  const [selectedRow, setSelectedRow] = React.useState<any>(null);
  const [multiSelectedRow, setMultiSelectedRow] = React.useState<IThreat[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [importThreatSource, setImportThreatSource] = useState<IThreatImport[]>(
    []
  );
  const [openTsImport, setOpenTsImport] = useState(false);
  const hasFetched = useRef(false);
  const [dialogForm, setDialogForm] = React.useState({
    title: "",
    action: "",
    actionCancel: "",
    openDialog: false,
  });
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openMultipleDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });
  const { threatSourceList, setThreatSourceList } = useRiskAssessmentContext();

  const handleEdit = (row?: any) => {
    // Implement edit logic here
    setSelectedRow(row);
    setDialogForm({
      title: "Edit Threat Source",
      action: "Ok",
      actionCancel: "Cancel",
      openDialog: true,
    });
  };
  const confirmDeleteAll = async () => {
    const threatIds = multiSelectedRow.map(item => item.threatID)
    try {
      const res = await getExistingThreat(companyProfileID, threatIds);
      if (res) {
        setDialogState({
          title: "Info",
          body: `Few threats are assigned to Risk Assessments. Please un-assign from Risk Assessment list and then try to delete.`,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openMultipleDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      } else {
        setDialogState({
          title: "Confirmation",
          body: `Are you sure you want to delete the selected threats`,
          action: "Delete",
          actionCancel: "Cancel",
          openDeleteConfirmationDialog: false,
          openMultipleDeleteConfirmationDialog: true,
          openSuccessDialogBox: false,
        });
      }
    } finally {
      setIsLoading(false)
    }
  }
  const handleDelete = async (row: any) => {
    setSelectedRow(row);
    setIsLoading(true)
    try {
      const res = await getExistingThreat(companyProfileID, [row.threatID]);
      if (res) {
        setDialogState(() => ({
          title: "Info",
          body: `<strong>${row.threatName}</strong> cannot be removed as it is assigned to Risk Assessments. Please un-assign from Risk Assessments plan and then remove.`,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openMultipleDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        }));
      } else {
        setDialogState(() => ({
          title: "Confirmation",
          body: `Are you sure you want to delete <strong>${row.threatName}</strong>?`,
          action: "Delete",
          actionCancel: "Cancel",
          openDeleteConfirmationDialog: true,
          openMultipleDeleteConfirmationDialog: false,
          openSuccessDialogBox: false,
        }));
      }
    } finally {
      setIsLoading(false)
    }
  };

  const handleMultipleDeleteConfirm = async () => {
    handleCloseDialog()
    setIsLoading(true)
    const payload = multiSelectedRow.map(item => item.threatID)
    const res = await deleteMultipleIThreat(userId, payload)
    if (res.succeeded) {
      setDialogState({
        title: "Success",
        body: `Threats has been deleted successfully `,
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openMultipleDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
      getThreatList();
      setMultiSelectedRow([])
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openMultipleDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  }



  const handleDeleteThreatSource = async () => {
    handleCloseDialog()
    setIsLoading(true);

    try {
      const date = new Date();
      const payload = {
        threatID: selectedRow.threatID,
        updateDate: date,
        updatedBy: userId,
        isDeleted: true,
      };
      const res = await deleteIThreat(payload);
      // console.log("handleDeletePolicy res", payload, res);
      if (res.succeeded === true) {
        setDialogState({
          title: "Success",
          body: `<strong>${selectedRow.threatName}</strong> successfully deleted`,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openMultipleDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
        getThreatList()
      } else {
        setDialogState({
          title: "Error",
          body: "Unexpected Error",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openMultipleDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      }
    } finally {
      setSelectedRow([]);
      getThreatList()
    }
  };
  const handleSelectRow = (selectedRows: IThreat[]) => {
    setMultiSelectedRow(selectedRows);
  };

  const handleAdd = () => {
    setSelectedRow(null);
    setDialogForm({
      title: "Create Threat Source",
      action: "Create",
      actionCancel: "Cancel",
      openDialog: true,
    });
  };
  const handleFormDialogClose = () => {
    setIsLoading(true);
    getThreatList();
    setDialogForm({
      ...dialogForm,
      openDialog: false,
    });
  };

  const getThreatList = async () => {
    setIsLoading(true)
    try {
      let Response = await getThreats(companyProfileID);
      let dialogResponse = Response.map((item) => ({
        ...item,
        rowId: item.threatID,
      })).sort((a, b) => {
        const nameA = a.threatName || '';
        const nameB = b.threatName || '';
        return nameA.localeCompare(nameB);
      })
      setThreatSourceList(dialogResponse);
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseDialog = () => {
    setDialogState({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openMultipleDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    });
  };


  const displayImportThreatSource = () => {
    setOpenTsImport(true);
  };
  const handleTsImportCancel = () => {
    setOpenTsImport(false);
  };

  useEffect(() => {
    if (!hasFetched.current) {
      getThreatList();
      hasFetched.current = true;
    }
  }, []);
  return (
    <React.Fragment>
      <Container sx={{ p: 1, height: "100%" }}>
        <Card sx={{ borderRadius: "10px", overflow: "hidden", height: "100%" }}>
          <CardContent>
            <Stack
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Stack alignItems="center" direction="row">
                <IconButton onClick={() => navigate("/risk-assessment")}>
                  <KeyboardBackspaceIcon />
                </IconButton>
                <Typography>Threat Sources</Typography>
              </Stack>
              <Stack alignItems="center" direction="row" spacing={2}>
                <Button
                  size="small"
                  variant="contained"
                  className="table-btn"
                  disabled={multiSelectedRow.length < 1}
                  onClick={() => confirmDeleteAll()}
                >
                  Delete
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#0066FF1A",
                    color: "#0066FF",
                    "&:hover": {
                      bgcolor: "#0066FF1A",
                      "& .MuiTypography-root": {
                        color: "white",
                      },
                    },
                    boxShadow: 0,
                    textTransform: "none",
                  }}
                  onClick={displayImportThreatSource}
                  disabled={!riskAssesment_CS_Access?.isImport || isLoading}
                >
                  Import
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#0066FF1A",
                    color: "#0066FF",
                    "&:hover": {
                      bgcolor: "#0066FF1A",
                      "& .MuiTypography-root": {
                        color: "white",
                      },
                    },
                    boxShadow: 0,
                    textTransform: "none",
                  }}
                  onClick={handleAdd}
                  disabled={!riskAssesment_CS_Access?.isCreate || isLoading}
                >
                  {`Create New Threat Source`}
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#0066FF1A",
                    color: "#0066FF",
                    "&:hover": {
                      bgcolor: "#0066FF1A",
                      "& .MuiTypography-root": {
                        color: "white",
                      },
                    },
                    boxShadow: 0,
                    textTransform: "none",
                  }}
                  onClick={() => exportExcelThreatSource(threatSourceList)}
                  disabled={threatSourceList.length === 0 || isLoading}
                >
                  Download Spreadsheet
                </Button>
              </Stack>
            </Stack>
            <Container
              maxWidth="sm"
              sx={{
                mt: 1,
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {isLoading ? (
                <ListItem
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CircularProgress />
                </ListItem>
              ) : (
                <CSDataTable
                  rows={threatSourceList}
                  columns={columns}
                  multiRowSelection={true}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  handleSelectRow={(selectedRows) =>
                    handleSelectRow(selectedRows)
                  }
                />
              )}
            </Container>
          </CardContent>
        </Card>
      </Container>
      {/* delete confirmation */}
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeleteThreatSource}
          handleCancel={handleCloseDialog}
        />
      }
      {/* delete All confirmation */}
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openMultipleDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleMultipleDeleteConfirm}
          handleCancel={handleCloseDialog}
        />
      }
      {
        <TsImport
          openDialog={openTsImport}
          handleCancel={handleTsImportCancel}
          refreshList={() => getThreatList()}
        />
      }
      {
        <DialogBoxForm
          openDialogBox={dialogForm.openDialog}
          dialogTitle={dialogForm.title}
          dialogAction={dialogForm.action}
          dialogActionCancel={dialogForm.actionCancel}
          threatSourceList={threatSourceList}
          row={selectedRow}
          handleCancel={handleFormDialogClose}
        />
      }
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
      {/* Open Import Dialog Box */}
    </React.Fragment>
  );
}
